import socialMediaPlayer from './social-media-player'
export default socialMediaPlayer
